import { Component, Inject, Input, Output, EventEmitter } from 'ng-metadata/core';
import './collection-bulk-action.component.scss';

/**
 * @ngdoc directive
 * @name mwCollectionBulkAction
 * @module mw.components.collection
 *
 * @param {array} [selected-items] DEPRECATED: An array of selected item objects.  Items can be of any type.  This has been deprecated, use selected-items-count instead.
 * @param {number} [selected-items-count] The number of selected items.
 * @param {expression} [on-reset-selected-items] Angular expression to evaluate when the cancel icon is clicked.
 *
 * @description
 * `<mw-collection-bulk-action>` is a component used for searching on items in a data table.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-collection-bulk-action selected-items-count="$ctrl.selectedItems.length" on-reset-selected-items="$ctrl.handleReset()">
 *      <mw-icon-button svg-icon="communication:ic_email_24px" hover="true" tooltip="Share" ng-click="$ctrl.customAction('Share')"></mw-icon-button>
 *      <mw-icon-button svg-icon="meltwater:tag" hover="true" tooltip="Tag" ng-click="$ctrl.customAction('Tag')"></mw-icon-button>
 *   </mw-collection-bulk-action>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-collection-bulk-action',
    template: `
        <md-toolbar class="mw-collection-bulk-action__selected-items-toolbar mw-collection-bulk-action__toolbar md-table-toolbar md-menu-toolbar">
            <div class="md-toolbar-tools">
                <md-button class="mw-collection-bulk-action__cancel-selection-button md-icon-button" aria-label="{{'mw-collection-bulk-action__cancel-selection' | translate}}" ng-click="$ctrl.handleResetSelectedItems($event)">
                    <md-icon md-svg-icon="navigation:ic_close_24px"></md-icon>
                    <md-tooltip md-delay="500" md-z-index="1"><span translate="mw-collection-bulk-action__cancel-selection"></span></md-tooltip>
                </md-button>
                <span class="mw-collection-bulk-action__header-title" translate="mw-collection-bulk-action__items-selected" translate-values="{length: $ctrl.formattedNumber}" translate-interpolation="messageformat"></span>
                <div flex></div>
                <div layout="row" layout-align="center" class="mw-collection-bulk-action__content-slot" ng-transclude></div>
            </div>
        </md-toolbar>
    `,
    legacy: {
        transclude: true
    }
})
export class CollectionBulkActionComponent {
    @Input('<') selectedItems: any[] = [];
    @Input('<') selectedItemsCount: number;
    @Output() onResetSelectedItems = new EventEmitter<any>();

    constructor(@Inject('$filter') private $filter) {
        'ngInject';
    }

    get formattedNumber() {
        return this.selectedItemsCount ? this.$filter('mwTruncateNumber')(this.selectedItemsCount) : this.$filter('mwTruncateNumber')(this.selectedItems.length);
    }

    handleResetSelectedItems() {
        this.onResetSelectedItems.emit(null);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/collection/collection-bulk-action-header/collection-bulk-action.component.ts